var map = {
	"./ask.svg": "688a",
	"./book.svg": "cda0",
	"./case.svg": "07e34",
	"./cat-data-manager.svg": "32df",
	"./cat-disband-team-1.svg": "9b02",
	"./cat-disband-team.svg": "f825",
	"./cat-fold.svg": "41e5",
	"./cat-lock-team.svg": "0359",
	"./cat-project.svg": "adc2",
	"./cat-system.svg": "1da5",
	"./cat-task.svg": "2c37",
	"./cat-tb.svg": "576e",
	"./cat-team.svg": "be38",
	"./cat-tm.svg": "aa281",
	"./cat-unfold.svg": "9fb1",
	"./cat-user.svg": "0b60",
	"./cat.svg": "5dfb",
	"./catalog.svg": "dee4",
	"./catalog_old.svg": "af87",
	"./chatbot.svg": "4853",
	"./classhour.svg": "97ef",
	"./course.svg": "8037",
	"./deepcat-logo-head.svg": "ebc2",
	"./deepcat-logo-login.svg": "dd3b",
	"./deepcat-logo.svg": "aadd",
	"./delete-line.svg": "8331",
	"./delete-row.svg": "77f0",
	"./deletrowcolum.svg": "68b6",
	"./detail.svg": "8a05",
	"./exam.svg": "761f",
	"./expand-all.svg": "e935",
	"./export-asset.svg": "cf85",
	"./fit-page.svg": "eda23",
	"./flash.svg": "7d24",
	"./glossary.svg": "58aa",
	"./history.svg": "7afb",
	"./home.svg": "0331",
	"./homework.svg": "5bac",
	"./insert-line.svg": "974b",
	"./insert-row.svg": "5493",
	"./insertrowcolum.svg": "431b",
	"./question.svg": "5d9e",
	"./right.svg": "6ffa",
	"./statistics.svg": "7e06",
	"./student-group.svg": "f3db",
	"./student-manager.svg": "48b2",
	"./studentEx.svg": "54b8",
	"./teacherEx.svg": "5027",
	"./teaching.svg": "b8a4",
	"./tm.svg": "5618",
	"./training.svg": "8964",
	"./training1.svg": "886d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";